import { FONT_LINK_ID, fontHref } from '@event67/shared';

// The brand fonts are named by the event, so their stylesheet URL cannot be a
// static <link> in index.html. `fontHref` builds it and lives in
// `@event67/shared`, because the admin console's form preview has to load the
// same families by the same URL to be a preview of anything. Installing the
// element stays here: shared is on the backend's dependency path and cannot
// touch the DOM.
export { fontHref };

/**
 * Points the page's font stylesheet at `href`, creating the link on first use.
 *
 * One element, reused: the theme changes when a visitor moves between events in
 * the same session, and appending a fresh <link> each time would leave the
 * previous event's fonts loaded and racing.
 */
export const installFontLink = (doc: Document, href: string | null): void => {
  if (!href) return;
  const existing = doc.getElementById(FONT_LINK_ID) as HTMLLinkElement | null;
  if (existing) {
    if (existing.href !== href) existing.href = href;
    return;
  }
  const link = doc.createElement('link');
  link.id = FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = href;
  doc.head.appendChild(link);
};
